import type { ReactNode } from 'react';
import styled from 'styled-components';
import { spacing } from 'ui/theme';

/** default layout is the typical wrapper on most pages */
const StyledFullWidth = styled.div`
  margin-left: -${spacing.layoutLRPadding};
  margin-right: -${spacing.layoutLRPadding};
`;

type Props = {
  children: ReactNode;
  id?: string;
};

export const FullWidth = ({ children, id, ...props }: Props) => (
  <StyledFullWidth data-test="full-width" id={id} {...props}>
    {children}
  </StyledFullWidth>
);
